export const stat = {
  table: {
    field: {
      src: 'Source',
      dst: 'Destination',
      date: 'Date',
      time: 'Time',
      duration: 'Duration',
      type_answer: 'Type Answer',
      sip_account: 'SIP account',
      contact: 'Contact',
      recording: 'Recording'
    }
  },

  common: {
    field: {
      date: 'Date',
      internal: 'Internal',
      external: 'External',
      incoming: 'Incoming',
      outgoing: 'Outgoing',
      total: 'Total',
      acd: 'ACD',
      asr: 'ASR'
    },

    block: {
      main: 'Calls',
      asr: 'ASR',
      acd: 'ACD'
    },

    filter: {
      group_by: {
        title: 'Group by',
        values: {
          date: 'Date',
          contact: 'Contact',
          sip_account: 'SIP account',
          destination: 'Destination',
          type: 'Type'
        }
      }
    }
  },

  detailed: {
    field: {
      type: 'Type',
      destination: 'Destination'
    }
  },

  call_type: {
    incoming: 'Incoming',
    outgoing: 'Outgoing'
  },

  call_destination: {
    internal: 'Internal',
    external: 'External'
  },

  type_answer: {
    ANSWERED: 'Answered',
    FAILED: 'Failed',
    CANCELED: 'Canceled',
    REJECTED: 'Rejected',
    NO_ANSWER: 'No answered'
  },

  contact_not_fixed: 'Contact is not fixed',
  sip_not_fixed: 'SIP account is not fixed',


  errors: {
    date: 'Invalid date period',
    date_period: 'The specified period should not exceed 7 days'
  },

  tooltips: {
    period: 'The specified period should not exceed 7 days',
    one_sip_account: 'The first fixed SIP account is&nbsp;displayed',
    sip_not_fixed: 'These may be calls to the entry point in the routing scheme of the PBX or other situations where the operator\'s account could not be fixed.'
  }
};
